<template>
	<div class="layout_body clearfix">

		<!-- <el-container style="position: absolute;left: 0;top: 0;bottom: 0;right: 0; overflow: hidden; background: #edeef0;"> -->
		<el-container>
			<el-header class="d-flex align-items-center" style="background: #34383f;">
				<div style="width: 1200px; margin: 0 auto;">
					<a class="h5 text-light mb-0 mr-auto float-left" style="margin-top: 9px; display:inline-block;">
						<!-- {{$conf.logo}} -->
						<img src="../assets/logo_img.png" />
					</a>
					
					<el-menu mode="horizontal" @select="handleSelect" background-color="#34383f"
					 text-color="#fff" active-text-color="#ffd04b" style="float: right;">
					
						<!-- <el-menu-item :index="index|numToString" 
					v-for="(item,index) in navBar.list"
					:key="index">{{item.name}}</el-menu-item -->
						<el-submenu index="100">
							
							<template slot="title">
								<!-- <el-avatar size="small" :src="user.thumb ? user.thumb : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"></el-avatar> -->
								{{user.user_name ? user.user_name : user.mobile}}
							</template>
							<!-- <el-menu-item index="100-1">修改手机号</el-menu-item> -->
							<el-menu-item index="100-2">退出</el-menu-item>
						</el-submenu>
					</el-menu>
					<div class="hd_inform">
						<el-tooltip class="item" effect="light" content="帮助" placement="top-start">
						  <i class="el-icon-question" @click="nav_help"></i>
						</el-tooltip>
						<el-tooltip class="item" effect="light" content="通知" placement="top-start">
						  <i class="el-icon-message-solid" @click="nav_inform"></i>
						</el-tooltip>
						<!-- <i class="el-icon-question"></i> -->
						<!-- <i class="el-icon-message-solid"></i> -->
					</div>
				</div>
			</el-header>
			
			<el-container style="height: 100%; width: 1200px; margin: 75px auto 0;">
				<!-- 侧边布局 -->
				<el-aside style=" width: 200px; margin-right: 20px;" class="aside_wrap clearfix">
					
					<!-- <el-menu :default-active="slideMenuActive" 
					@select="slideSelect"
					style="height: 100%; border-left: solid 1px #e6e6e6;">
					  <el-menu-item :index="index|numToString" :key="index"
					  v-for="(item,index) in slideMenus">
						<i :class="item.icon"></i>
						<span slot="title">{{item.name}}</span>
					  </el-menu-item>
					</el-menu> -->
					<!-- $route.path -->
					<el-menu :default-active="routerPath" :default-openeds="openeds" router class="el-menu-vertical-demo" background-color="#fff"
					 text-color="#212121" active-text-color="#007bff" style="height: auto; border: 1px solid rgba(0,0,0,.125);">
						 <!-- <div class="workbench_tab">
							 <i class="el-icon-s-platform" style="width: 24px; text-align: center; margin-right: 5px;"></i>
							 <span slot="title">工作台</span>
						 </div> -->
						 <!--v-if="!user.certified" -->
						<el-menu-item v-if="user_infor.certified ==1" index="/index" @click="aside_list" style=" border-bottom: 1px solid rgba(0, 0, 0, 0.125);">
							<i class="el-icon-s-platform el-icon"></i>
							<span>控制台</span>
						</el-menu-item>
						
						<!-- 未认证通过显示 -->
						<el-menu-item v-if="user_infor.certified ==0" index="/unverified/state" @click="aside_list" style=" border-bottom: 1px solid rgba(0, 0, 0, 0.125);">
							<i class="el-icon-s-platform el-icon"></i>
							<span>工作台</span>
						</el-menu-item>
						 
						<el-submenu v-if="user.certified ==1" index="1">
							<template slot="title">
								<i class="el-icon-s-marketing el-icon"></i>
								<span>客户管理</span>
							</template>
							<el-menu-item index="/client/statistics" @click="aside_list">客户统计</el-menu-item>
						</el-submenu>
						
						<el-submenu v-if="user.certified ==1" index="2">
							<template slot="title">
								<i class="el-icon-s-finance el-icon"></i>
								<span>财务管理</span>
							</template>
							<el-menu-item index="/finance/stats" @click="aside_list">财务统计</el-menu-item>
							<!-- <el-menu-item index="/finance/income" @click="aside_list">收入明细</el-menu-item> -->
						</el-submenu>
						
						<el-submenu v-if="user.certified ==1" index="3">
							<template slot="title">
								<i class="el-icon-s-custom el-icon"></i>
								<span>赏金猎手</span>
							</template>
							<el-menu-item index="/hunter/poster" @click="aside_list">推广海报</el-menu-item>
							<!-- <el-menu-item index="/huntsman_marketing" @click="aside_list">营销推广</el-menu-item> -->
						</el-submenu>
						<el-submenu v-if="user.certified ==1" index="4">
							<template slot="title">
								<i class="el-icon-s-custom el-icon"></i>
								<span>保险箱</span>
							</template>
							<el-menu-item index="/safe/safeData" @click="aside_list">保险箱</el-menu-item>
							<!-- <el-menu-item index="/safe/withdrawAudit" @click="aside_list">提现明细</el-menu-item> -->
						</el-submenu>
						<el-submenu index="5">
							<template slot="title">
								<i class="el-icon-s-tools el-icon"></i>
								<span>系统设置</span>
							</template>
							<el-menu-item v-if="user.certified_status ==0 || user.certified_status ==2" index="/settings/basicInformation" @click="aside_list">认证赏金猎人</el-menu-item>
							<el-menu-item v-if="user.is_super ==1" index="/settings/templateList" @click="aside_list">模板列表</el-menu-item>
							<!-- <el-menu-item index="/settings/hunterInfor" @click="aside_list">赏金猎人信息</el-menu-item> -->
							<el-menu-item index="/settings/notifyList" @click="aside_list">通知列表</el-menu-item>
							<el-menu-item index="/settings/helpList" @click="aside_list">帮助列表</el-menu-item>
						</el-submenu>
					</el-menu>
					
				</el-aside>
				<!-- 侧边布局 -->
				
				<!-- 主布局 -->
				<el-main style=" position: relative; background: #fff; margin-bottom: 100px;" v-loading="loading">

					<!-- 面包屑导航 -->
					<!-- <div class="border-bottom mb-3 bg-white" 
				v-if="bran.length > 0"
				style="padding: 20px;margin: -20px;">
					<el-breadcrumb separator-class="el-icon-arrow-right">
					  <el-breadcrumb-item v-for="(item,index) in bran"
					  :key="index" :to="{ path: item.path }">
						  {{item.title}}</el-breadcrumb-item>
					</el-breadcrumb>
				</div> -->

					<!-- <ul class="list-group" v-if="!this.$route.meta.iSation">
						<li class="list-group-item">赏金猎人线上准入操作手册<router-link to="">点击详情</router-link>
						</li>
					</ul> -->
					<!-- 主内容 -->
					<router-view></router-view>


					<el-backtop target=".el-main" :bottom="100">
						<div style="height: 100%; width: 100%; background-color: #f2f5f6; box-shadow: 0 0 6px rgba(0,0,0, .12); text-align: center;  line-height: 40px; color: #1989fa;">UP</div>
					</el-backtop>

				</el-main>
			</el-container>
		</el-container>

	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	import {
		Center
	} from '../common/api/http.js'
	export default {
		data() {
			return {
				bran: [],
				loading: false,
				openeds:['1','2','3','4','5'],
				user_infor:'',//用户信息
			}
		},
		mounted() {
			
			// 请求我的
			let token = window.sessionStorage.getItem('token')
			Center({
				'api_token': token
			}).then(res=>{
				if(res.code==0){
					this.user_infor = res.data
					// 存储到vuex
					let data = res.data
					// 存储到本地存储
					this.$store.commit('login', data)
					
					//认证状态
					if(this.$route.path != '/index'){
						if(res.data.certified_status == 3){
							this.$router.push({
								name: 'index'
							})
						}
					}
					
					if(this.$route.path != '/unverified/state'){
						if(res.data.certified_status == 0 || res.data.certified_status == 1 || res.data.certified_status== 2){
							this.$router.push({
								name: 'unverified_state'
							})
						}
					}
				}
			})
			// 请求我的
		},
		computed: {
			...mapState({
				user: state => state.user.user
			}),
			routerPath:{
				get: function () {
				  return this.$route.meta.guidePath?this.$route.meta.jumpPath:this.$route.path
				},
				set: function (newValue) {
				  this.$route.meta.guidePath?this.$route.meta.jumpPath:newValue
				}
				// return this.$route.meta.guidePath?this.$route.meta.jumpPath:this.$route.path
			}
		},
		methods: {
			//帮助
			nav_help(){
				this.$router.push({
					name: 'settings_helpList'
				})
			},
			//通知
			nav_inform(){
				this.$router.push({
					name: 'settings_notifyList'
				})
			},
			//侧边路由跳转
			aside_list(key){
				// console.log(key.index)
				// if(key.index == '/index'){
				// 	this.$router.push({name:'index'})
				// }else if (key.index == '/guest/stats'){
				// 	this.$router.push({name:'guest_stats'})
				// }else if(key.index == '/attestation/basicInformation'){
				// 	this.$router.push({name:'attestation_basicInformation'})
				// }
				// let user = window.sessionStorage.getItem('user')
				// user = JSON.parse(user)
				// if(user.certified ==0){
				// 	// alert('未认证')
				// 	// this.routerPath = '/attestation/basicInformation'
				// 	// this.$route.path = '/attestation/basicInformation'
				// 	return false
				// }
				// else{
				// 	if(key.index == '/index'){
				// 		this.$router.push({name:'index'})
				// 	}else if (key.index == '/guest/stats'){
				// 		this.$router.push({name:'guest_stats'})
				// 	}else if(key.index == '/attestation/basicInformation'){
				// 		this.$router.push({name:'attestation_basicInformation'})
				// 	}
				// }
				
			},
			handleSelect(key, keyPath) {
				if (key === '100-1') {
					return console.log('修改资料')
				}
				if (key === '100-2') {
					// 退出登录
					return this.logout()
				}
				this.navBar.active = key
				// 默认选中跳转到当前激活
				this.slideMenuActive = '0'
				if (this.slideMenus.length > 0) {
					this.$router.push({
						name: this.slideMenus[this.slideMenuActive].pathname
					})
				}
			},
			// 退出登录
			logout() {
				this.$message('退出成功')
				// 清除状态和存储
				this.$store.commit('logout')
				// 返回到登录页
				this.$router.push({
					name: "page_home"
				})
				
				localStorage.clear(); //清除缓存
			}
		}
	}
</script>

<style lang="less">
	html,body {height: 100%; background: #edeef0;}
	.layout_body { width: 100%; height: 100%; background: #edeef0;}
	.el-container {
		 background: #edeef0;
	}
	// body { background: #edeef0;}
	.el-header { position: fixed; left: 0; top: 0; width: 100%; z-index: 11;}
	.hd_inform {
		float: right; color: #fff; line-height: 60px;
		i {
			margin: 0 10px; cursor: pointer;
		}
	}
	.el-menu-item.is-active {
		/* background: pink; */
	}
	.workbench_tab {
		background: #34383f; color: #fff; height: 56px; line-height:56px; padding: 0 20px; box-sizing: border-box;
	}
	.aside_wrap {
		.el-submenu__title:hover {
			// background-color: pink !important;
		}
		.el-menu {
			.el-submenu__title { font-weight: bold;}
			.el-icon {
				width: 20px !important; height: 20px; border-radius: 50%; background-color: #34383f; line-height: 20px; color: #fff !important; font-size: 12px !important;
			}
			.el-submenu__icon-arrow {
				color: #34383f !important; font-weight: bold;
			}
		}
		.el-submenu {
			border-bottom: 1px solid rgba(0, 0, 0, 0.125);
			.el-menu-item {
				border-top: 1px solid rgba(0, 0, 0, 0.125);
			}
		}
		.el-submenu .el-menu-item {
			min-width: 198px !important;
		}
	}
</style>
